/**
 * Remap a Y in continuous scroll content (after padding) when page heights
 * scale by `zoomRatio` but inter-page gaps stay fixed in CSS pixels.
 *
 * `getPageHeightAtNewZoom` must return heights at the destination zoom.
 * Pre-zoom heights are inferred as newHeight / zoomRatio.
 */
export function scaleContinuousContentY(
  contentY: number,
  zoomRatio: number,
  totalPages: number,
  getPageHeightAtNewZoom: (page: number) => number,
  pageGap: number
): number {
  if (totalPages <= 0 || zoomRatio === 0) {
    return contentY * zoomRatio
  }
  if (zoomRatio === 1) {
    return contentY
  }

  let oldCursor = 0
  let newCursor = 0

  for (let page = 1; page <= totalPages; page++) {
    const newHeight = getPageHeightAtNewZoom(page)
    const oldHeight = newHeight / zoomRatio

    if (contentY < oldCursor + oldHeight || page === totalPages) {
      return newCursor + (contentY - oldCursor) * zoomRatio
    }

    oldCursor += oldHeight
    newCursor += newHeight

    if (contentY < oldCursor + pageGap) {
      return newCursor + (contentY - oldCursor)
    }

    oldCursor += pageGap
    newCursor += pageGap
  }

  return newCursor
}
